<template>
	<div>
        <img src="../../../assets/i5gam/images/tempServiceStop.jpg">
    </div>
	<!-- <div class="layer-content common">
		<div class="__layer-type-dt" style="padding:0 20px 10px;">
			<div class="entry-tit">
				<div class="img-com __icon26"><span>안내 아이콘</span></div><span class="pc01">
				[긴급] 무통장입금 어린이집 입금정보 확인요청 안내입니다.</span>
				<div class="txt-type4 mgt10" style="color:#e4392e;font-size:16px !important;font-family: 'NotoKrR';font-weight:600;">단, 카드로 결제한 시설은 제외입니다.</div>
			</div>
			<ol class="txt-type1 depth2 mgt20">
				<li>① 걸음마 아이오감의 비용을 <span class="pc02">무통장으로 입금한 시설</span>에 한하여  답변을 부탁드립니다.</li>
				<li>② 걸음마 아이오감 리더기 및 태그비용을 입금하실때  <span class="pc02">입금자명에 사업자번호(고유번호)로 입력</span>부탁드립니다.</li>
			    <li>③ 기존에 어린이집명으로 입금된 어린이집의 경우, 동일한 어린이집 명이 많아 확인이 지연되고 있습니다.</li>
			    <li>④ <span class="pc02">신속한 입금확인</span>을 위해 적극적인 협조부탁드립니다.</li>
			</ol>
		</div>
		<div class="box-type02">
			<div style="padding:5px 10px;border-bottom:1px solid #e0e0e0;background:#fafafa;text-align:center;line-height:22px;">무통장 입금을 진행한 어린이집에 한해  <span class="pc02">아래의 정보를 기록</span>하여<br />저희 걸음마 아이오감 메일  <span class="pc02">i5gam@onandon.co.kr</span>로 보내주시기 바랍니다.</div>
			<ul class="depth1" style="overflow:hidden;padding:10px 20px 10px;">
				<li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>입금일자 :</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>입금통장 계좌번호 :</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>사업자번호 :</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>어린이집명 :</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>리더기 설치여부 :</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>입금액 : </li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>수량 : 리더기 =&nbsp;&nbsp;n대,&nbsp;&nbsp;태그 =&nbsp;n개</li>
		        <li style="float:left;width:50%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>청구세금계산사 수령여부 : O, X로 표시요망</li>
		        <li style="float:left;width:100%;"><div class="img-com _bt-ic08 mgl0 mgr8"><span>아이콘</span></div>추가요청사항 : 예) 리더기 비용과 태그비용을 분리해서 세금계산서를 발행해주세요.</li>
			</ul>
		</div>
	</div> -->
</template>

<script>
export default {
    name : 'installDateInfoPopup',
    props: ['index'],
    methods : {
        /* btn_cloudClick : function(){
            this.$router.push({ name: 'views.i5gam.cs.cloud'});
            this.$store.commit('closePopup', this.index);
        } */
    },
}
</script>